<template>
    <div>
        <div
            v-for="answer in displayedAnswer"
            class="question-content"
            v-if="
            displayedAnswer.length > 0
            "
        >
            <b>Answered: &nbsp;</b> {{ answer }}
        </div>
    </div>
</template>

<script>
export default {
  name: "resultsQuestion",
  props: {
    questionContent: {
      type: Array
    },
    resp: {
      type: Object
    },
    qType: {
        type: String
    },
  },

  methods: {
    compareAnswer(resp, qType, aI) {
      //Gets a string value representing an answer in the question, compares it to the tester response at question index qI with answer index aI
      //console.log(resp.responses[qI]);

      if (qType == "dropdown" || qType == "multi-choice") {
        return aI == resp.value;
      }

      if (qType == "multi-select") {
        return resp.value.includes(aI);
      }

      if (qType == "linear-scale") {
        if (aI == 1) {
          return true;
        }
        return false;
      }

      if (qType == "text-answer") {
        return true;
      }
    },
  }, 
  computed: {
    displayedAnswer: function () {
      let arr = []
      for (let i = 0; i < this.questionContent.length;i++) {
        if (this.compareAnswer(this.resp, this.qType, i)) {
          if (this.qType == "linear-scale") {
            arr.push(this.resp.value);
          }
          else if (this.questionContent[i] == "Text Answer") {
            arr.push(this.resp.value);
          }
          else {
            arr.push(this.questionContent[i]);
          }
        }
      }
      return arr
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/game-detail/Surveys/ResultsQuestion.vue